/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-useless-escape */
import React, { useState } from 'react';
import { Row, Col, Form, Modal, Button } from 'react-bootstrap';
import { toast } from 'react-hot-toast';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../features/Loader/LoaderSlice';
const ForgetPasswordModal = ({ isOpen, setIsOpen }) => {
  const dispatch = useDispatch();
  const [mailOpen, setMailOpen] = useState(true);
  const [verificationOpen, setVerificationOpen] = useState(false);
  const [user, setUser] = useState({
    username: '',
    password: '',
    cpassword: '',
    code: ''
  });

  const { username, password, cpassword, code } = user;

  const onChange = (e) => setUser({ ...user, [e.target.name]: e.target.value }); // replace the typed text as value

  const sendOtp = () => {
    const getUrl = process.env.REACT_APP_API_URL;
    const url = getUrl;
    if (!username || username.length <= 0) {
      toast.error('Please enter complete email address', { id: 'email' });
    } else if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        username
      )
    ) {
      toast.error('Please enter a valid email address', { id: 'email' });
    } else {
      dispatch(loaderActions.show());
      axios
        .post(
          `${url}/forgot_password`,
          {
            username
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
        .then((result) => {
          if (result.status === 200) {
            toast.success('OTP sent successfully! Please check your email', { id: 'success' });
          } else {
            toast.error(result.data);
          }
          setMailOpen(false);
          setVerificationOpen(true);
        })
        .catch((err) => {
          console.error(
            'Error occurred during addition\nError: ',
            err.response.data.message ?? err.response.data
          );
          toast.error(err.response.data.message ?? err.response.data, { id: 'error' });
        })
        .finally(() => {
          dispatch(loaderActions.hide());
        });
    }
  };

  const changeEmail = () => {
    setMailOpen(true);
    setVerificationOpen(false);
  };

  const resetPassword = () => {
    const getUrl = process.env.REACT_APP_API_URL;
    const url = getUrl;
    if (!username || username.length <= 0) {
      toast.error('Please enter complete email address', { id: 'email' });
    }
    if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        username
      )
    ) {
      toast.error('Please enter a valid email address', { id: 'email' });
    } else if (!password || password.length <= 0) {
      toast.error('Please enter a valid password', { id: 'password' });
    } else if (password !== cpassword) {
      toast.error('Passwords not match!', { id: 'password' });
    } else if (!/^(?=.{6,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W)/.test(password)) {
      toast.error('Please enter a valid password', { id: 'password' });
    } else {
      dispatch(loaderActions.show());
      axios
        .post(
          `${url}/confirm_forgot_password`,
          {
            Username: username,
            password,
            code
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
        .then((result) => {
          if (result.status === 200) {
            setIsOpen(false);
            toast.success('Password changed successfully!', { id: 'success' });
          } else {
            toast.error(`${result.data}`);
          }
        })
        .catch((error) => {
          if (error.response) {
            toast.error(`${error.response.data}`);
          }
        })
        .finally(() => {
          dispatch(loaderActions.hide());
        });
    }
  };

  return (
    <React.Fragment>
      <Modal show={isOpen} centered onHide={() => setIsOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">
            {verificationOpen ? 'Reset Password' : 'Forgot Password'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col sm={12}></Col>
            <Col sm={12}>
              <div className="form-group fill"></div>
            </Col>
          </Row>
          {mailOpen === true ? (
            <Form.Row>
              <Form.Control
                className="text-normal"
                size="lg"
                type="email"
                placeholder="Email Address"
                required
                name="username"
                value={username}
                onChange={onChange}
              />

              <div className="mt-4" style={{ width: '100%' }}>
                <Button
                  size="small"
                  className="login_forgot_password_button"
                  onClick={sendOtp}
                  block
                >
                  Send OTP
                </Button>
              </div>
            </Form.Row>
          ) : null}
          {verificationOpen ? (
            <div>
              <div className="row">
                <div className="col text-center">
                  <h2>Confirm Check Email</h2>
                  <p>
                    Enter the OTP sent to <u>{username}</u> to verify your identity
                  </p>
                  <Form.Group as={Col} controlId="formGridEmail">
                    <Form.Control
                      size="lg"
                      className="login_form"
                      as="input"
                      type="password"
                      placeholder={'OTP Code'}
                      required
                      maxLength="6"
                      name="code"
                      value={code}
                      onChange={onChange}
                      onFocus={(e) => e.target.select()}
                    />
                  </Form.Group>
                </div>
              </div>
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Control
                  className="login_form"
                  as="input"
                  type="password"
                  size="lg"
                  placeholder={'New Password'}
                  required
                  name="password"
                  value={password}
                  onChange={onChange}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Control
                  size="lg"
                  className="login_form"
                  as="input"
                  type="password"
                  placeholder={'Confirm New Password'}
                  required
                  name="cpassword"
                  value={cpassword}
                  onChange={onChange}
                />
              </Form.Group>
              <div className="mt-2 px-3" style={{ width: '100%' }}>
                <Button
                  size="small"
                  className="btn btn-primary"
                  onClick={resetPassword}
                  style={{
                    borderRadius: '5px'
                  }}
                  block
                >
                  Reset Password
                </Button>
              </div>
            </div>
          ) : (
            <></>
          )}
        </Modal.Body>
        {verificationOpen ? (
          <Modal.Footer>
            <Row>
              <Col md={{ span: 12 }}>
                Haven't Received OTP ?
                <Button variant="link" onClick={() => sendOtp()}>
                  Resend
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 12 }}>
                Not your email ?
                <Button variant="link" onClick={() => changeEmail()}>
                  Change
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        ) : (
          <Modal.Footer></Modal.Footer>
        )}
      </Modal>
    </React.Fragment>
  );
};
export default ForgetPasswordModal;
